import { Option } from '@bbl-digital/snorre-v2'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BoardDocumentFilterSharedWithBblEnum } from 'shared/microServices/portalDocuments/models/BoardDocumentQueryModel'
import { RootState } from 'shared/store/store'

type Filter = {
  searchString?: string
  selectedTags?: Option[]
  documentType?: string
  fileType?: string
  currentPage?: number
  pageSize?: number
  startDate?: string
  endDate?: string
  sharedWithBbl?: BoardDocumentFilterSharedWithBblEnum
}

const initialState: Filter = {
  searchString: '',
  selectedTags: [],
  sharedWithBbl: BoardDocumentFilterSharedWithBblEnum.Unfiltered,
  documentType: '',
  fileType: '',
  currentPage: 1,
  pageSize: 10,
  startDate: '',
  endDate: '',
}

const bblArchiveSlice = createSlice({
  name: 'bblArchive',
  initialState,
  reducers: {
    resetBBLArchiveFilters: (state) => {
      state.searchString = initialState.searchString
      state.selectedTags = initialState.selectedTags
      state.sharedWithBbl = initialState.sharedWithBbl
      state.documentType = initialState.documentType
      state.fileType = initialState.fileType
      state.currentPage = initialState.currentPage
      state.startDate = initialState.startDate
      state.endDate = initialState.endDate
    },
    setBBLSearchString: (state, action: PayloadAction<string>) => {
      state.searchString = action.payload
    },
    setBBLSelectedTags: (state, action: PayloadAction<Option[]>) => {
      state.selectedTags = action.payload
    },
    setBBLSharedWithBbl: (
      state,
      action: PayloadAction<BoardDocumentFilterSharedWithBblEnum>
    ) => {
      state.sharedWithBbl = action.payload
    },
    setBBLDocumentType: (state, action: PayloadAction<string>) => {
      state.documentType = action.payload
    },
    setBBLFileType: (state, action: PayloadAction<string>) => {
      state.fileType = action.payload
    },
    setBBLCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    setBBLPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload
    },
    setBBLFilter: (state, action: PayloadAction<Filter>) => {
      state.searchString = action.payload.searchString
      state.selectedTags = action.payload.selectedTags
      state.sharedWithBbl = action.payload.sharedWithBbl
      state.documentType = action.payload.documentType
      state.fileType = action.payload.fileType
      state.currentPage = action.payload.currentPage
      state.startDate = action.payload.startDate
      state.endDate = action.payload.endDate
    },
  },
})

export const {
  resetBBLArchiveFilters,
  setBBLSearchString,
  setBBLSelectedTags,
  setBBLSharedWithBbl,
  setBBLDocumentType,
  setBBLFileType,
  setBBLCurrentPage,
  setBBLPageSize,
  setBBLFilter,
} = bblArchiveSlice.actions

export default bblArchiveSlice

export const getBBLArchiveFilters = (state: RootState) => state.bblArchive
